<template>
  <component :is="component" v-if="component" v-bind="props" />
  <ProviderOverrideMe
    v-else
    :provider="provider"
    component="PlanDrawerContent"
  />
</template>
<script setup lang="ts">
  import { computed } from "vue"
  import { useLocalizedComponents } from "@versatile-credit-apply/components"

  import type { HasPaymentPlanProp } from "./PlanPropTypes"
  const props = defineProps<HasPaymentPlanProp>()

  const provider = computed(() => {
    return props.plan.providerKey
  })

  const component = useLocalizedComponents(() => props.plan, {
    fortiva_standard: () =>
      import(
        "@/providers/fortiva_standard/components/FortivaPlanDrawerContent.vue"
      ),
    genesis_standard: () =>
      import(
        "@/providers/genesis_standard/components/GenesisPlanDrawerContent.vue"
      ),
  })
</script>
